export function formatHex(hex, params = {}) {
    const { width, head = 6, tail = 4 } = params;
    if (width !== undefined && (width > 1410 || (940 > width && width > 800))) {
        return hex;
    }
    return `${hex.slice(0, head)}...${hex.slice(hex.length - tail)}`;
}
//# sourceMappingURL=format-hex.js.map